import vuetify from '@/plugins/vuetify';
import labels from "@/constants/labels.js";
import messages from "@/constants/messages.js";
import parameters from "@/constants/parameters.js";
import calculatorsLabels from "@/constants/labels/calculators.labels.js";
var crypto = require("crypto-js");

const _getTimestamp = function () {
  let date = new Date();
  return date.getTime();
}

const _setupScreenSizes = function (context, paddingDiff = 0) {
  setTimeout(
    function () {
      if (context.$refs.screenHeader && context.$refs.screenContent) {
        const headerHeight = context.$refs.screenHeader.offsetHeight + 8 - (paddingDiff || 0);
        context.$refs.screenContent.style.paddingTop = headerHeight + "px";
        context.$vuetify.goTo(0, {
          duration: 0,
          offset: 0,
          easing: "easeInOutCubic",
        });
        if (context.scrollHeight == 0) {
          context.scrollHeight = document.body.offsetHeight - headerHeight;
        }
        return;
      }
      _setupScreenSizes(context, paddingDiff);
    }.bind(context),
    100
  );
}

const _isCordovaApp = function () {
  try {
    return cordova !== 'undefined';
  } catch {
    return false;
  }
}
const _capitalize = function (s) {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}
const _getLabel = function (propName, propOrigin = 'labels') {
  const originLabel = {
    'calculators': function () {
      return calculatorsLabels[propName];
    },
    'labels': function () {
      return labels[propName];
    }
  }
  if (originLabel[propOrigin]) {
    return originLabel[propOrigin]();
  }
  throw new Error('Invalid property.');
}
const _getParameter = function (prop) {
  return parameters[prop];
}
const _roundNumber = function (value, decimals) {
  return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}
const _formatNumber = function (x) {
  x = x.toString().replace('.', ',');
  x = x.split(',');
  x[0] = x[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ")
  return x.join(',');
}
export default {
  methods: {
    _scrollToZero(ctx) {
      ctx.$vuetify.goTo(0, {
        duration: 0,
        offset: 0,
        easing: 'easeInOutCubic',
      })
    },
    _getDocumentById(id) {
      return document.getElementById(id);
    },
    _getUpperCaseFirstLetter(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase();
    },
    _getHourMinutesSeconds(d) {
      let h = Math.floor(d / 3600);
      let m = Math.floor((d % 3600) / 60);
      let s = Math.floor((d % 3600) % 60);

      let hDisplay = h > 0 ? h + (h == 1 ? " hora, " : " horas, ") : "";
      let mDisplay = m > 0 ? m + (m == 1 ? " minuto, " : " minutos, ") : "";
      let sDisplay = s > 0 ? s + (s == 1 ? " segundo, " : " segundos, ") : "";
      return (hDisplay + mDisplay + sDisplay).slice(0, -2);
    },
    _getNumber(num) {
      return new Number((num || '0').replace(',', '.'));
    },
    _strToNumber(str) {
      if (str.length && ['.', ','].includes(str[str.length - 1])) {
        str = str.slice(0, -1);
      }
      return new Number(str.replace(/\./g, '').replace(',', '.'))
    },
    _roundNumber,
    _formatNumber,
    _formatAndRoundNumber(value, decimals = 2) {
      return _formatNumber(_roundNumber(value, decimals));
    },
    _isPopulatedArray(arr) {
      return !!arr && arr.length > 0;
    },
    _getComputedStyleFromElement(el, prop) {
      return window
        .getComputedStyle(el)
        .getPropertyValue(prop);
    },
    _pixelsToNumber(pixels) {
      return Number(pixels.replace("px", "").trim());
    },
    _hash(str) {
      return crypto.SHA256(str).toString();
    },
    _encrypt(obj, supressSpecialChars = false) {
      let encrypted = crypto.AES.encrypt(JSON.stringify(obj), process.env.VUE_APP_SECRET).toString();
      if (supressSpecialChars) {
        encrypted = encrypted.replace(/\+/g, 'p1L2u3S').replace(/\//g, 's1L2a3S4h').replace(/=/g, 'e1Q2u3A4l');
      }
      return encrypted;
    },
    _decrypt(str, supressSpecialChars = false) {
      if (!str) return str;
      if (supressSpecialChars) {
        str = str.replace(/p1L2u3S/g, '+').replace(/s1L2a3S4h/g, '/').replace(/e1Q2u3A4l/g, '=');
      }
      str = crypto.AES.decrypt(str, process.env.VUE_APP_SECRET);
      return JSON.parse(str.toString(crypto.enc.Utf8));
    },
    _isValidFullName(name) {
      return !!name && typeof name === 'string'
        && name.trim().split(' ').length > 1;
    },
    _getMaxWidth() {
      return 768;
    },
    _filterArrayFromString(array, string) {
      return array.filter(o =>
        Object.keys(o).some(k =>
          o[k].toLowerCase().includes(string.toLowerCase())
        )
      );
    },
    _filterArrayFromId(array, id) {
      return array.filter(o => {
        return o.id == id;
      });
    },
    _getPlatform: function () {
      return !_isCordovaApp() ? 'website' : cordova.platformId;
    },
    _isAndroidWeb: function () {
      return !_isCordovaApp() && /android/i.test(navigator.userAgent);
    },
    _isIosWeb: function () {
      return !_isCordovaApp() && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },
    _isIos: function () {
      try {
        return cordova && cordova !== 'undefined' && cordova.platformId !== 'android';
      } catch {
        return false;
      }
    },
    _isAndroid: function () {
      try {
        return cordova && cordova !== 'undefined' && cordova.platformId === 'android';
      } catch {
        return false;
      }
    },
    _isCordovaApp,
    _getUserAgent() {
      return navigator.userAgent || navigator.vendor || window.opera;
    },
    _isMobile: function () {
      return vuetify.framework.breakpoint.sm || vuetify.framework.breakpoint.xs;
    },
    _isNotEmpty(arr) {
      return arr && arr.length;
    },
    _removeFromArray(arr, item) {
      var temp = [];
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] != item) {
          temp.push(arr[i]);
        }
      }
      return temp;
    },
    _removeFromArrayWithId(arr, id) {
      var temp = [];
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].id != id) {
          temp.push(arr[i]);
        }
      }
      return temp;
    },
    _doesArrayContainAllElementsOfAnother(parent, child) {
      let matchesCount = 0;
      child.forEach(c => {
        if (parent.includes(c)) {
          matchesCount += 1;
        }
      });
      return matchesCount == child.length;
    },
    _removeFromArrayWithName(arr, name) {
      var temp = [];
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].name != name) {
          temp.push(arr[i]);
        }
      }
      return temp;
    },
    _orderById(arr) {
      arr.sort(function (a, b) {
        return a.id - b.id;
      });
      return arr;
    },
    _sortByProp(arr, prop) {
      if (!arr) return [];
      arr = arr.sort(function (a, b) {
        return a[prop] > b[prop] ? 1 : -1;
      });
      return arr;
    },
    _setupScreenSizes,
    _getTimestamp,
    _removeAccents(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    _createIdentifier(str) {
      return str.replace(/ /g, "").split("?").join("").toLowerCase().split(".").join("").split(",").join("").split("/").join("").split("-").join("").split(":").join("").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    _capitalizeAllFirstLetters(str) {
      if (typeof str !== 'string') { throw new Error('Invalid Argument') }
      str = str.split(' ');
      for (let i = 0; i < str.length; i++) {
        str[i] = _capitalize(str[i].trim().toLowerCase());
      }
      return str.join(' ');
    },
    _capitalize,
    _validURL(str) {
      var pattern = new RegExp('^(https?:\\/\\/)?' +
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
        '((\\d{1,3}\\.){3}\\d{1,3}))' +
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
        '(\\?[;&a-z\\d%_.~+=-]*)?' +
        '(\\#[-a-z\\d_]*)?$', 'i');
      return !!pattern.test(str);
    },
    _getWindowHeight(diff) {
      return (window.screen.height || window.innerHeight) - (diff || 0);
    },
    _getWindowWidth(diff) {
      return (window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth) - (diff || 0);
    },
    _shallowEqual(object1, object2) {
      if (!object1 || !object2) {
        return false;
      }

      const keys1 = Object.keys(object1);
      const keys2 = Object.keys(object2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (let key of keys1) {
        if (object1[key] !== object2[key]) {
          return false;
        }
      }

      return true;
    },
    _convertFileToDataUrl: async function (file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();

        reader.onloadend = function () {
          resolve(reader.result);
        }

        if (file) {
          reader.readAsDataURL(file);
        } else {
          reject();
        }
      });
    },
    _getCalculatorsLabel(propName) {
      return _getLabel(propName, 'calculators');
    },
    _getLabel,
    _getMessage(prop) {
      return messages[prop] || '';
    },
    _getParameter,
    _formatHeaderContent(context, headerRef, contentRef) {
      setTimeout(
        function () {
          if (context.$refs[headerRef] && context.$refs[contentRef]) {
            let headerHeight = context.$refs[headerRef].offsetHeight + 1;
            context.$refs[contentRef].style.paddingTop =
              headerHeight + "px";
            context.$vuetify.goTo(0, {
              duration: 0,
              offset: 0,
              easing: "easeInOutCubic",
            });
          }
        },
        100
      );
    },
    _formatNumberField(element, value = "", inputLength = 9) {
      if (element.srcElement.value.length <= inputLength) {
        element.srcElement.value = element.srcElement.value.replace(".", ",");
        let arr = element.srcElement.value.split(",");
        value = "";
        arr.forEach((item, index) => {
          if (index == 0) {
            item = parseInt(item).toString() || "";
          } else if (index == 1) {
            value += ",";
          }
          value += item.replace(/\D+/g, "");
        });
        if (value.charAt(0) == ",") {
          value = "0" + value;
        }
      }
      element.srcElement.value = value;
      return { value };
    },
    _getElapsedSeconds(startTime, endTime = null) {
      if (typeof startTime !== 'number' || (!!endTime && typeof endTime !== 'number')) {
        throw new Error();
      }
      let elapsed = endTime || _getTimestamp();
      elapsed = elapsed - startTime;
      elapsed = elapsed / 1000;
      return parseInt(elapsed);
    },
    _getLocaleDate(time) {
      if (!time) return "";
      return new Date(typeof time === 'string' ? parseInt(time) : time).toLocaleDateString(_getParameter('LOCALE'), {
        day: 'numeric', month: 'short', year: 'numeric'
      }).replace(/ /g, ' ').replace('.', '');
    },


    _isValidEmail: (email) => {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return (
        email &&
        !!email.trim() &&
        re.test(String(email.trim()).toLowerCase())
      );
    },

    _shuffle: function (array) {
      let currentIndex = array.length, randomIndex;

      // While there remain elements to shuffle.
      while (currentIndex != 0) {

        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], array[currentIndex]];
      }

      return array;
    }
  },
};
